import axios from "axios";
import UserManager from "../_helpers/userManager";
import Role from "../_helpers/role";
import API from "../_helpers/endpointService";
import { useNavigate } from "react-router-dom"

export default class AuthService {
  constructor() {
    UserManager.events.addUserLoaded((user) => {
      if (user.access_token && window.location.href.indexOf("signin") !== -1) {
        this.setUserInfo({
          accessToken: user.access_token,
          idToken: user.id_token,
          email: user.profile.email,
        });
      }
    });

    UserManager.events.addSilentRenewError((e) => {
    });

    UserManager.events.addAccessTokenExpired(() => {
      this.logout();
    });
  }

  signinRedirect = () => {
    UserManager.signinRedirect();
  };

  
  signinRedirectCallback = () => {
    return UserManager.signinRedirectCallback();
  };

  logout = () => {
    UserManager.signoutRedirect();
    localStorage.clear();
    UserManager.clearStaleState();
    window.location.replace("/");
  };

  signoutRedirectCallback = () => {
    UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear();
      UserManager.clearStaleState();
      window.location.replace("/");
    });
  };

  navigateToScreen = (userDetails) => {   
    let url = `${API.AUTHENTICATE_USER}?email=${userDetails.email}`;
    axios.get(url)
      .then((response) => {
        if (response.data == true) {
          let url1 = `${API.USER_ROLE}?id=${(userDetails.sub)}`;
          axios.get(url1)
            .then((response1) => {
              let userRole = "";
              localStorage.setItem("UserRoles", response1?.data?.Name);
              userRole = response1?.data?.Name;
              if (userRole === Role.Admin || userRole === Role.ShipOwner || userRole === Role.Supervisor || userRole === Role.YardInCharge) {
                window.location.replace("/projectlist");
              }
              else {
                window.location.replace("/unautherized");
              }
            })
            .catch((error) => {
            
            });
        }
        else {
          window.location.replace("/usernotfound");
        }
      })
      .catch((error) => {
       
      })
 };

  isAuthenticated = () => {
    let currentUser = localStorage.getItem("currentUser");
    let oidcStorage = JSON.parse(currentUser);
    return !!oidcStorage && !!oidcStorage.idToken;
  };

  getUser = async () => {
    const user = await UserManager.getUser();
    if (!user) {
      return await UserManager.signinRedirectCallback();
    }
    return user;
  };

  getUserRole = async () => {
    let userRole = localStorage.getItem("userRole");
    return userRole;
  };

  getCurrentUserDetails = async () => {
    let currentUserDetails = localStorage.getItem("currentUser");
    let userDetails = JSON.parse(currentUserDetails);
    return userDetails;
  };

  parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    if (base64Url) {
      const base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    } else {
      try {
        const parsedToken = JSON.parse(window.atob(token));
        return parsedToken;
      } catch (error) {
        return token;
      }
    }
  };

  setUserInfo = authResult => {
    const accessData = this.parseJwt(authResult.accessToken);
    const idData = this.parseJwt(authResult.idToken);


    const data1 =
      typeof accessData === "string"
        ? { accessToken: authResult.accessToken }
        : { ...accessData };
    const data2 =
      typeof idData === "string"
        ? { idToken: authResult.idToken }
        : {
          ...idData,
          email: authResult.email
        };
    const data = {
      ...data1,
      ...data2,
      ...authResult,
    };

    localStorage.setItem("currentUser", JSON.stringify(data));
    axios.defaults.headers.common['authorization'] = `Bearer ${authResult.accessToken}`;
    this.navigateToScreen(data);
  };

  signinSilent = () => {
    UserManager.signinSilent()
      .then((user) => {
      })
      .catch((err) => {
      });
  };

  signinSilentCallback = () => {
    UserManager.signinSilentCallback();
  };

  createSigninRequest = () => {
    return UserManager.createSigninRequest();
  };
}
